import type { ReactNode } from 'react';
import { cn } from '#client/lib/cn';

interface PageProps {
  title: ReactNode;
  subtitle?: ReactNode | undefined;
  primaryAction?: ReactNode | undefined;
  secondaryActions?: ReactNode | undefined;
  backAction?: ReactNode | undefined;
  fullWidth?: boolean | undefined;
  children: ReactNode;
  className?: string | undefined;
}

/** Page frame: a header with title and action slots above the content. */
export function Page({
  title,
  subtitle,
  primaryAction,
  secondaryActions,
  backAction,
  fullWidth = false,
  children,
  className,
}: PageProps) {
  return (
    <div className={cn('c-page', fullWidth && 'c-page--full', className)}>
      <header className="c-page__header">
        <div className="c-page__heading">
          {backAction}
          <div>
            <h1 className="c-page__title">{title}</h1>
            {subtitle && <p className="c-page__subtitle">{subtitle}</p>}
          </div>
        </div>
        {(secondaryActions || primaryAction) && (
          <div className="c-page__actions">
            {secondaryActions}
            {primaryAction}
          </div>
        )}
      </header>
      <div className="c-page__body">{children}</div>
    </div>
  );
}
